import { Events } from "@auvious/utils";
import hark from "hark";
function createAudioContext() {
    // @ts-ignore
    // eslint-disable-next-line compat/compat
    return new (window.AudioContext || window.webkitAudioContext)();
}
export class VAD {
    constructor() {
        this.name = "auvious.vad";
        this.events = new Events();
        this.streamIn = null;
        this.hark = null;
        this.options = {
            smoothing: 0.25,
            interval: 80,
            threshold: -65,
        };
    }
    setInput(stream) {
        var _a;
        const trackNew = stream.getAudioTracks()[0];
        const trackOld = (_a = this.streamIn) === null || _a === void 0 ? void 0 : _a.getAudioTracks()[0];
        this.streamIn = stream;
        if (this.hark) {
            if (!trackNew) {
                this.stop();
            }
            else if (trackOld !== trackNew) {
                this.stop();
                this.setup();
            }
        }
        else if (trackNew) {
            this.setup();
        }
        this.events.emit("output", stream);
    }
    /** output is not transformative and can be ignored */
    onOutput(callback) {
        this.events.on("output", callback);
        return () => this.events.off("output", callback);
    }
    onUnload(callback) {
        this.events.on("unload", callback);
        return () => this.events.off("unload", callback);
    }
    /** setup or update options (threshold, interval) */
    setup(options = {}) {
        this.options = Object.assign(Object.assign({}, this.options), options);
        if (this.options.threshold > 0) {
            this.options.threshold = Math.min(0, Math.max(-100, this.options.threshold - 100));
        }
        if (this.hark) {
            this.hark.setInterval(this.options.interval);
            this.hark.setThreshold(this.options.threshold);
            return;
        }
        if (!this.streamIn || this.streamIn.getAudioTracks().length === 0) {
            return;
        }
        this.options.audioContext = VAD.audioContext;
        this.hark = hark(this.streamIn, this.options);
        let lastVolume = 0;
        this.hark.on("volume_change", (volume) => {
            const speaking = volume >= this.options.threshold;
            const vol = speaking ? Math.max(0, Math.min(100, volume + 100)) : 0;
            if (vol !== lastVolume)
                this.events.emit("activity", {
                    speech: speaking,
                    volume: (lastVolume = vol),
                });
        });
        this.hark.resume();
    }
    stop() {
        var _a;
        (_a = this.hark) === null || _a === void 0 ? void 0 : _a.stop();
        this.hark = null;
    }
    dispose() {
        this.stop();
        this.events.emit("unload");
    }
}
VAD.audioContext = createAudioContext();
